import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import Media from 'react-media';

import ProfileImage from './ProfileImage';
import ProfileForm from './ProfileForm';
import ProfileFooter from './ProfileFooter';
import CustomIcon from '../../common/CustomIcon';
import * as accountActions from '../../../actions/accountActions';
import * as drawerActions from '../../../actions/drawerActions';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';

export class UserProfile extends React.Component {
  static propTypes = {
    closable: PropTypes.bool,
    user: PropTypes.object,
    studentProfile: PropTypes.object,
    accountActions: PropTypes.object,
    drawerActions: PropTypes.object
  };

  // Same as the footer's cancel: discard unsaved changes and close the drawer
  close = () => {
    const { accountActions, drawerActions, user } = this.props;

    accountActions.setNewUserData(user);
    drawerActions.setDrawerClosed();
  };

  // Mobile (Vista Mobile): the drawer takes the whole screen, so it needs its own close button
  renderMobileHeader = () => {
    const { studentProfile } = this.props;

    return (
      <div className="drawer-header user-profile-header">
        <span className="drawer-header-cursor" role="button" aria-label={I18n.t('common.close')}>
          <CustomIcon onClick={this.close} name="close-button" size={24} />
        </span>
        <div className="drawer-header-title">{!studentProfile && I18n.t('userProfile.settings')}</div>
      </div>
    );
  };

  renderProfileContent = () => {
    const { closable } = this.props;

    return (
      <div className={`user-profile-content ${closable ? 'closable' : ''}`}>
        {closable && <Media query={MOBILE_MEDIA_QUERY}>{isMobile => isMobile && this.renderMobileHeader()}</Media>}
        <ProfileImage />
        <ProfileForm />
      </div>
    );
  };

  renderProfileFooter = () => {
    return <ProfileFooter />;
  };

  render() {
    return (
      <div className="user-profile">
        <div className="user-profile-content-wrapper">
          {this.renderProfileContent()}
          {this.renderProfileFooter()}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    user: state.account.user,
    studentProfile: state.student.selectedStudent
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
